import { ChangeDetectionStrategy, ViewEncapsulation, Component, inject } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-app/shared/control-value-accessor-validator-base';
import { FiOnboardingCategoryType } from '@fi-app/fi-onboarding/fi-onboarding-enums';
import { FiOnboardingHelperService } from '@fi-app/fi-onboarding/fi-onboarding-helper.service';

@Component({
    selector: 'fi-onboarding-category-settings',
    templateUrl: './fi-category-settings.component.html',
    styleUrls: ['./fi-category-settings.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-onboarding-category-settings' },
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiOnboardingCategorySettingsComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiOnboardingCategorySettingsComponent,
            multi: true,
        },
    ],
})
export class FiOnboardingCategorySettingsComponent extends ControlValueAccessorValidatorBase<FiOnboardingCategoryType> {
    private readonly fiOnboardingHelperService = inject(FiOnboardingHelperService);

    protected readonly availableCategoryTitles = this.fiOnboardingHelperService.availableCategoryTitles;
    protected readonly FiOnboardingCategoryType = FiOnboardingCategoryType;
}
